import { PriorityTypes } from './ticket.item';

export interface ITicketWidgetItem  {
    TicketID: number;
    AdminID: number;
    MemberID: number;
    TicketNR: string;
    Name: string;
    Email: string;
    Subject: string;
    Status: string;
    Priority: PriorityTypes;
}

export class TicketWidgetItemArray extends Array<TicketWidgetItem>  {

    constructor(...items: TicketWidgetItem[]) {
        super(...items);
        Object.setPrototypeOf(this, TicketWidgetItemArray.prototype);
    }

}

export class TicketWidgetItem  implements ITicketWidgetItem {
    TicketID: number;
    AdminID: number;
    MemberID: number;
    TicketNR: string;
    Name: string;
    Email: string;
    Subject: string;
    Status: string;
    Priority: PriorityTypes;
}
